<template>
  <el-container>
    <el-header>
      <navmenu/>
    </el-header>
    <el-main>
      <div class="block">
        <el-carousel trigger="click" height="460px" indicator-position="none" arrow="never">
          <el-carousel-item v-for="item in imgList" :key="item.name">
            <div class="pic_item">
              <img :src="item.src" style="height:100%;width:100%;" alt="图片丢失了" />
              <h3>{{item.title}}</h3>
              <p>{{item.detail}}</p>
            </div>
          </el-carousel-item>
        </el-carousel>
        <div class="visualNav">
          <ul>
            <a href="#/visual/product"><li class="icon_a"><span></span>产品<div></div></li></a>
            <a href="#/visual/developmentPlatform"><li class="icon_b"><span></span>开发平台<div></div></li></a>
            <a href="#/visual/apply"><li class="icon_c"><span></span>可视化应用<div></div></li></a>
            <a href="#/visual/digitalTwin"><li class="icon_d"><span></span>数字孪生应用<div></div></li></a>
            <a href="#/visual/caseIntroduction"><li class="icon_e actived"><span></span>案例介绍</li></a>
          </ul>
        </div>
      </div>
        <div class="digital_1">
          <div class="share">
            <div style="height:45px;width:415px;margin:0 auto;"><h2>案例介绍</h2></div>
            <span></span>
          </div>       
          <div class="caseImg">
            <div class="fl_l">
              <div class="aud_web" @click="videoPlay('webGl')">
                <img src="../../../public/visualImg/WebGL.png" alt="">
                <div class="btn" @click="videoPlay('webGl')"><img src="../../../public/visualImg/video_btn.png" alt=""></div>
              </div>
              <div class="tit"><p>WebGL引擎视频</p></div>
            </div>
            <div class="fl_r">
              <div class="aud_web" @click="videoPlay('SISG')">
                 <img src="../../../public/visualImg/SISG.jpg" alt="">
                 <div class="btn" @click="videoPlay('SISG')"><img src="../../../public/visualImg/video_btn.png" alt=""></div>
              </div>
              <div class="tit"><p>某钢厂产线视频</p></div>
            </div>
          </div>
          <div class="view-tip">
            <div class="detail">
              <p>更多案例请联系我们。（邮箱：marketing@comzen.net）</p>
            </div>
          </div>
        </div>
    </el-main>
    <el-footer>
      <footerMenu/>
    </el-footer>

      <!-- 视频弹窗 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :width="flag==='webGl' ? '900px' : '1000PX'"
      :before-close="handleClose"
      >
      <video v-if="flag==='webGl'" autoplay controls>
        <source src="../../../public/visualImg/WebGL.mp4">
      </video>
      <video v-if="flag==='SISG'" src="../../../public/visualImg/SISG.mp4" autoplay controls></video>
    </el-dialog>
  </el-container>
</template>

<script>
import navmenu from '../../components/navmenu.vue';
import footerMenu from '../../components/footer.vue';

export default {
  components: { navmenu,footerMenu },

  data(){
    return{
      dialogVisible:false,
      flag:null,
      imgList:[
        {
          name: "banner1",
          title:'可视化',
          detail:'Visualization',
          src: require("../../../public/visualImg/visualbaner.png"),
        },
      ]
    }
  },
  methods:{
    videoPlay(flag){
      this.flag = flag
      this.dialogVisible = true
    },
    handleClose(){
      this.dialogVisible = false
      this.flag = null
    }
  }
}
</script>
<style lang="scss" scoped>
.share{
  padding:80px 0 60px 0;
  span{
    height: 3px;
    width: 44px;
    display: inline-block;
    background-color: #C5C5C5;
  }
}

.block{
  position: relative;
  .pic_item {
    position: relative;
    height: 100%;
    h3{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 132px;        
      font-size: 60px;
      font-family: PingFang SC;
      font-weight: 800;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:moveh3 3s infinite;
      // animation-iteration-count:1;
      @keyframes moveh3{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
      @-webkit-keyframes moveh3 /*Safari and Chrome*/{
        from {left:60%;opacity: 0;}
        to {left:50%;opacity: 1;}
      }
    }      
    p{
      position: absolute;
      width: 1200px;
      left: 50%;
      transform: translateX(-50%);
      text-align: left;
      top: 242px;        
      font-size: 20px;
      font-family: PingFang SC;
      font-weight: 400;
      line-height: 100px;
      color: #FFFFFF;
      opacity: 1;
      animation:movep 3s infinite;
      @keyframes movep{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
      }
      @-webkit-keyframes movep /*Safari and Chrome*/{
        from {top: 282px;opacity: 0;}
        to {top: 242px;opacity: 1;}
    }
    }      
  }
  .pic_item:hover{
    cursor: pointer;
  }
  .visualNav{
    width: 100%;
    height: 98px;
    margin-top: 60px;
    border-top: 1px solid rgba(51, 51, 51, 0.15);
    border-bottom: 1px solid rgba(51, 51, 51, 0.15);
    ul{
      width: 1200px;
      margin: 0 auto;
      display: flex;
      justify-content: space-around;
      text-align: center;
      vertical-align: middle !important;
      a{width: 100%;}
      li{
        height: 100px;
        line-height: 100px;
        width: 100%;
        div{
          width: 1px;
          height: 20px;
          background:#ccc ;
          float: right ;
          margin-top: 40px;
        }
      }
      li:hover{
        // background-color:rgb(212,239,253);
        a{
          color: #fff;
        }
      }
      .icon_a{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_a.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 70px;background-position-y: 38px;
      }
      .icon_a:hover{
        span{

          background: url("../../../public/visualImg/icon_a1.png") no-repeat;
        }
        background-position-x: 70px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .actived {color: #fff;}
      .icon_b{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_b.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 54px;background-position-y: 38px;
      }
      .icon_b:hover{
        span{

          background: url("../../../public/visualImg/icon_b1.png") no-repeat;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_c{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_c.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 48px;background-position-y: 38px;
      }
      .icon_c:hover{
        span{

          background: url("../../../public/visualImg/icon_c1.png") no-repeat;
        }
        background-position-x: 48px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_d{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_d.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 40px;background-position-y: 38px;
      }
      .icon_d:hover{
        span{

          background: url("../../../public/visualImg/icon_d1.png") no-repeat;
        }
        background-position-x: 40px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      .icon_e{
        span{
          display: inline-block;
          background: url("../../../public/visualImg/icon_e.png") no-repeat;
          width:24px;
          height:24px;
          vertical-align: middle;
        }
        background-position-x: 54px;background-position-y: 38px;
      }
      .actived,.icon_e:hover{
        span{

          background: url("../../../public/visualImg/icon_e1.png") no-repeat  ;
        }
        background-position-x: 54px;background-position-y: 38px;
        background: linear-gradient(360deg, #23C2E3 0%, #1E8DD4 100%);
      }
      
    }
    a{
      color: #333;
    }
    a:hover,a:active{
      color: #fff;
    }
  }
}

  .view-tip{
    width: 1200px;   
    margin: 0 auto;
    margin-bottom: 90px;
    text-align: left;
    .title{
      height: 33px;
      text-align: left;
      font-size: 24px;
      font-weight: bold;
      margin: 0 0 10px;
      padding-left: 10px;
      border-left: solid 3px #1E8DD4;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: pre !important;
    }
    .detail{
      margin-top: 32px;
      text-align: left;
      font-size: 16px;
      line-height: 32px;
      color: #666;
      padding-left: 13px;
      p{
        margin-top:-3px
      }
      span{
        font-size: 18px;
        font-weight: bold;
        line-height: 20px;
        margin-bottom: 10px;
      }
      ul{
        list-style-type: none;
        margin-left: 5px;
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        li{
          padding-bottom: 20px;
          // width: 326px;
        }
      }
    }
  }

.digital_1{
  height: 800px;
  .caseImg{
    height: 433px;
    margin: 0 auto;
    width: 1200px;
    // background-color: seashell;
    .tit{
      height: 70px;
      p{
        line-height: 35px;
        text-align: left;
        margin-left: 32px;
      }
    }
    .aud_web{
       position: relative;
       height: 363px;
      img{
        height: 363px;
        width: 588px;      
      }
      .btn{
        position: absolute;
        top: 326px;
        left: 24px;
        z-index: 3;
        img{
          width: 36px;
          height: 22px;
        }
      }
      .btn:hover{
        cursor: pointer;
      }
    }
    .aud_web:hover{
      cursor: pointer;
    }
    .fl_l{
      width: 588px;
      height: 433px;
      float: left;     
      box-shadow: 5px 5px 15px #eee;
    }
    .fl_r{
      float: right;
      width: 588px;
      height: 433px;
      box-shadow: 5px 5px 15px #eee;
    }
  }
  
}
/deep/.el-dialog__headerbtn{
  font-size: 24px !important;
}
</style>


// WEBPACK FOOTER //
// src/views/visual/caseIntroduction.vue